import { render, staticRenderFns } from "./_base-left-page-sub-menu.vue?vue&type=template&id=139d3135"
import script from "./_base-left-page-sub-menu.vue?vue&type=script&lang=js"
export * from "./_base-left-page-sub-menu.vue?vue&type=script&lang=js"
import style0 from "./_base-left-page-sub-menu.vue?vue&type=style&index=0&id=139d3135&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports